import React from 'react';

import { NotificationManager } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

import { BASE_PATH } from 'common/constants';

const PayMayaPopup = ({ id }) => {
  const handleClose = React.useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <DefaultPopup
      className="qr-modal"
      headerTitle="paymaya"
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <div
        className="popup__content paymaya"
        style={{
          backgroundImage: `url("${BASE_PATH}/static/assets/images/qr-code-bg-paymaya.png")`,
        }}
      />
    </DefaultPopup>
  );
};

export default PayMayaPopup;
